import { type SVGProps } from 'react';

export const Boxing = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="4 4 16 16" width="1em" {...props}>
    <path
      d="M15.92 4a4.13 4.13 0 013.015 1.303 3.96 3.96 0 011.048 3.063l-.665 7.179a.505.505 0 01-.508.455v3.5c0 .276-.229.5-.51.5H9.106a.505.505 0 01-.51-.5V16l-.071-.006-.034-.004-.044-.012-.039-.012-.025-.012a.518.518 0 01-.137-.088l-4.071-3.49A.494.494 0 014 12v-1.5C4 9.122 5.146 8 6.553 8h.854c0-.992.378-1.958 1.065-2.697A4.125 4.125 0 0111.486 4h4.433zm-4.25 12H9.618v3h8.17v-3h-6.116zm2.543 1c.282 0 .51.224.51.5s-.228.5-.51.5h-1.021c-.281 0-.51-.224-.51-.5s.229-.5.51-.5h1.022zM15.92 5h-4.433a3.05 3.05 0 00-2.26.977 2.972 2.972 0 00-.786 2.297l.015.141a.538.538 0 01.007.069L9.107 15h9.236l.622-6.725a2.962 2.962 0 00-.787-2.299A3.05 3.05 0 0015.92 5zM7.483 9h-.93c-.844 0-1.532.673-1.532 1.5v1.273l2.95 2.528L7.484 9z"
      fill="currentColor"
    />
  </svg>
);
